import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Typography,
  notification,
} from "antd";
import KopThermalBill from "../Kitchen/KOT/kot-thermal-bill";
import config from "../../config";
import Loader from "../loader";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useBilling } from "../Kitchen/billingProvider";
import { useCustomerData } from "../../provider/billingProviders/customerDataProvider";
import { v4 } from "uuid";
import moment from "moment";
import { useKotDraft } from "../Kitchen/KOT/draftProvider";
import { useFooterData } from "../../provider/billingProviders/footerDataProvider";
import { useKotDraftB2b } from "../Kitchen/KOT/kotDraftB2bProvider";

const KotPrintModal = ({ open, setOpen }) => {
  const [form] = Form.useForm();
  const [startPrinter, setStartPrinter] = useState(false);
  const [printerLoading, setPrinterLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const shopDetails = useSelector((state) => state.shopDetails);
  const [onGoingOrderList, setOnGoingOrderList] = useState([]);
  const {
    state: { addedProducts = [], b2bBill = false },
    getTotalAmount,
    clearAll,
  } = useBilling();
  const { customerName, customerPhoneNumber, clearCustomerData } =
    useCustomerData();
  const { clearFooterData } = useFooterData();
  const [draftBill, setDraftBill] = useKotDraft();
  const [kotDraftB2bBill, setKotDraftB2bBill] = useKotDraftB2b();
  const getRestaurantDraft = async (actionKey) => {
    try {
      const res = await fetch(`${config.newApiGateway}/draft/draft`, {
        method: "POST",
        body: JSON.stringify({
          action: "getDraft",
          shopId: shopDetails.shopId,
          employeeId: shopDetails.empId ? shopDetails.empId : "",
          shopTypeandCustomertype:
            actionKey === "restaurant-get"
              ? "restaurant"
              : actionKey === "restaurant-b2b-get"
              ? "restaurant-b2b"
              : actionKey,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      if (data.status === "SUCCESS") {
        if (actionKey === "restaurant-get") {
          setDraftBill(data.data);
        } else if (actionKey === "restaurant-b2b-get") {
          setKotDraftB2bBill(data.data);
        }
      }
    } catch (error) {
      console.log("getRestaurantDraftError", error);
    }
  };
  const createKot = async (payload) => {
    return await Promise.all([
      fetch(`${config.newApiGateway}/bill/createKot`, {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data.code === "SUCCESS") {
          setPrinterLoading(false);
          setStartPrinter(true);
          return data;
        }
        if (data.code === "ERROR") {
          setPrinterLoading(false);
          alert(data.message);
        }
      })
      .catch((err) => {
        console.log("err".err);
      });
  };
  const updateKot = async (payload) => {
    return await Promise.all([
      fetch(`${config.newApiGateway}/bill/createKot`, {
        method: "POST",
        body: JSON.stringify({
          action: "update",
          ...payload,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      }),
    ])
      .then(([res]) => Promise.all([res.json()]))
      .then(async ([data]) => {
        if (data.code === "SUCCESS") {
          setPrinterLoading(false);
          return data;
        }
        if (data.code === "ERROR") {
          setPrinterLoading(false);
          alert(data.message);
        }
      })
      .catch((err) => {
        console.log("err".err);
      });
  };

  const close = () => {
    console.log(
      "Notification was closed. Either the close button was clicked or duration time elapsed."
    );
  };

  const addToDraft = async (payload, actionKey) => {
    try {
      const response = await fetch(`${config.newApiGateway}/draft/draft`, {
        method: "POST",
        body: JSON.stringify({
          action: "createDraft",
          ...payload,
          employeeId: shopDetails.empId,
          shopTypeandCustomertype:
            actionKey === "restaurant-get"
              ? "restaurant"
              : actionKey === "restaurant-b2b-get"
              ? "restaurant-b2b"
              : actionKey,
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();

      if (data.status === "SUCCESS") {
      }
    } catch (error) {}
  };

  const updateDraftById = async (payload) => {
    try {
      const response = await fetch(`${config.newApiGateway}/draft/draft`, {
        method: "POST",
        body: JSON.stringify({
          action: "updateDraft",
          ...payload,
          employeeId: shopDetails.empId,
          shopTypeandCustomertype: "restaurant-update",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      console.log("addToDraft", data);
      if (data.status === "SUCCESS") {
      }
    } catch (error) {}
  };

  const handleYes = async (data, values) => {
    console.log("handleYes", data);
    let products = data.items;
    addedProducts.forEach((i) => {
      const isExist = products.find((j) => j.productId === i.productId);
      if (isExist) {
        products = products.map((product) => {
          if (product.productId === isExist.productId) {
            return {
              ...product,
              count: product.count + isExist.count,
              itemTotal: product.itemTotal + isExist.itemTotal,
            };
          }
          return product;
        });
      } else {
        products.push(i);
      }
    });

    console.log("products", products);

    const payload = {
      shopId: shopDetails.shopId,
      items: addedProducts,
      totalAmount: getTotalAmount(),
      ...(customerName !== "" && {
        customerName: customerName,
      }),
      ...(customerPhoneNumber !== "" && {
        customerPhoneNumber: customerPhoneNumber,
      }),
      orderId: data.orderId,
      orderType: values.orderType,
      tableNumber: values.tableNo,
      waiterName: values.waiterName,
    };

    const response = await updateKot(payload);
    await updateDraftById({
      billId: data.billId,
      items: products,
      totalAmount: data.totalAmount + getTotalAmount(),
    });
    let kotId = "";
    if (response.code === "SUCCESS") {
      kotId = response.data;
      console.log("kotId1212", kotId);
      const kotNo = document.getElementById("kotNo");
      kotNo.innerHTML = `No: ${kotId}`;
    }
    setStartPrinter(true);
    setPrinterLoading(false);
    setOpen(false);
    api.destroy();
  };

  const handleNo = async (values) => {
    setOpen(false);
    setPrinterLoading(true);
    const payload = {
      shopId: shopDetails.shopId,
      items: addedProducts,
      totalAmount: getTotalAmount(),
      ...(customerName !== "" && {
        customerName: customerName,
      }),
      ...(customerPhoneNumber !== "" && {
        customerPhoneNumber: customerPhoneNumber,
      }),
      orderType: values.orderType,
      tableNumber: values.tableNo,
      waiterName: values.waiterName,
    };
    const response = await createKot(payload);
    let kotId = "";
    if (response.code === "SUCCESS") {
      kotId = response.data;
      console.log("kotId1212", kotId);
      const kotNo = document.getElementById("kotNo");
      kotNo.innerHTML = `No: ${kotId}`;
    }
    var dBill = {
      billId: v4(),
      orderId: kotId,
      items: addedProducts,
      customerName: customerName,
      customerPhoneNumber: customerPhoneNumber,
      orderType: values.orderType,
      billDate: moment().format("DD-MM-YYYY HH:mm:ss"),
      totalAmount: getTotalAmount(),
      numberOfItems: addedProducts.length,
      tableNumber: values.tableNo,
      waiterName: values.waiterName,
      shopId: shopDetails.shopId,
    };
    if (b2bBill) {
      setKotDraftB2bBill((prev) => [...prev, dBill]);
      await addToDraft(dBill, "restaurant-b2b");
    } else {
      setDraftBill((prev) => [...prev, dBill]);
      await addToDraft(dBill, "restaurant");
    }

    api.destroy();
  };

  const handleSubmit = async (values) => {
    if (values.onGoingOrder === "new") {
      handleNo(values);
      return;
    } else if (values.onGoingOrder) {
      let orderData = {};
      if (b2bBill) {
        orderData = kotDraftB2bBill.find((i) => {
          return i.orderId === values.onGoingOrder;
        });
      } else {
        orderData = draftBill.find((i) => {
          return i.orderId === values.onGoingOrder;
        });
      }

      handleYes(orderData, values);
      return;
    }
    setPrinterLoading(true);
    setOpen(false);
    const payload = {
      shopId: shopDetails.shopId,
      items: addedProducts,
      totalAmount: getTotalAmount(),
      ...(customerName !== "" && {
        customerName: customerName,
      }),
      ...(customerPhoneNumber !== "" && {
        customerPhoneNumber: customerPhoneNumber,
      }),
      orderType: values.orderType,
      tableNumber: values.tableNo,
      waiterName: values.waiterName,
    };
    console.log("payload1212", payload);
    const response = await createKot(payload);
    let kotId = "";
    if (response.code === "SUCCESS") {
      kotId = response.data;
      const kotNo = document.getElementById("kotNo");
      kotNo.innerHTML = `No: ${kotId}`;
    }
    var dBill = {
      orderId: kotId,
      items: addedProducts,
      customerName: customerName ? customerName : "",
      customerPhoneNumber: customerPhoneNumber ? customerPhoneNumber : "",
      orderType: values.orderType,
      billingDate: moment().format("DD-MM-YYYY"),
      billingTime: moment().format("HH:mm:ss"),
      totalAmount: getTotalAmount(),
      numberOfItems: addedProducts.length,
      tableNumber: values.tableNo,
      waiterName: values.waiterName,
      shopId: shopDetails.shopId,
      parentShopId: shopDetails.ownerShopId,
    };
    console.log("dBill1212", b2bBill);
    if (b2bBill) {
      setKotDraftB2bBill((prev) => [...prev, dBill]);
      await addToDraft(dBill, "restaurant-b2b");
    } else {
      setDraftBill((prev) => [...prev, dBill]);
      await addToDraft(dBill, "restaurant");
    }
  };

  const handleClose = () => {
    form.resetFields();
    setOpen(false);
  };

  useEffect(() => {
    if (startPrinter) {
      var content = document.getElementById("kotPrintThermal");
      var pri = document.getElementById("kotPrint").contentWindow;
      pri.document.open();
      setTimeout(() => {}, 1000);
      pri.document.write(content.innerHTML);
      pri.document.close();
      pri.focus();
      pri.print();
      setStartPrinter(false);
      form.resetFields();
      clearAll();
      clearCustomerData();
      clearFooterData();
    }
  }, [startPrinter]);

  useEffect(() => {
    if (shopDetails.shopId) {
      getRestaurantDraft(b2bBill ? "restaurant-b2b-get" : "restaurant-get");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopDetails.shopId, b2bBill]);

  return (
    <>
      {printerLoading && (
        <div className="loading">
          <Loader size={56} />
        </div>
      )}
      {contextHolder}
      <iframe
        id="kotPrint"
        style={{
          height: 0,
          width: 0,
          position: "absolute",
        }}
        title="PRINT"
        // style="height: 0px; width: 0px; position: absolute"
      ></iframe>
      <div
        id="kotPrintThermal"
        style={{
          overflow: "hidden",
          height: "0px",
          position: "absolute",
        }}
      >
        <KopThermalBill
          data={{
            shopName: shopDetails.shopName,
            orderType: form.getFieldValue("orderType"),
            tableNo: form.getFieldValue("tableNo"),
            date: moment().format("DD-MM-YYYY"),
            time: moment().format("hh:mm A"),
            products: addedProducts,
          }}
        />
      </div>
      <Modal
        open={open}
        onCancel={handleClose}
        footer={false}
        centered
        width={400}
      >
        <Typography.Title
          level={4}
          style={{
            color: "#EF4667",
          }}
        >
          Create KOT
        </Typography.Title>
        <Divider />
        <Form
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          form={form}
          onFinish={handleSubmit}
          onFieldsChange={(changedField) => {
            const field = changedField[0];
            console.log("shopDetails", shopDetails);
            if (field.name[0] === "tableNo" && b2bBill) {
              const order = kotDraftB2bBill.filter((i) => {
                return i.tableNumber === field.value;
              });
              order?.sort((a, b) => {
                return a.orderId - b.orderId;
              });
              setOnGoingOrderList(order);
            } else if (field.name[0] === "tableNo" && !b2bBill) {
              const order = draftBill.filter((i) => {
                return i.tableNumber === field.value;
              });
              order?.sort((a, b) => {
                return a.orderId - b.orderId;
              });
              setOnGoingOrderList(order);
            }
          }}
        >
          <Form.Item
            label="Order Type"
            name="orderType"
            rules={[{ required: true, message: "Please select Order Type" }]}
          >
            <Select
              inputProps={{ "aria-label": "Without label" }}
              style={{
                width: "100%",
              }}
            >
              <Select.Option value={"dine_in"}>Dine In</Select.Option>
              <Select.Option value={"parcel"}>Parcel</Select.Option>
              <Select.Option value={"delivery"}>Delivery</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.orderType !== currentValues.orderType
            }
          >
            {({ getFieldValue }) => {
              return getFieldValue("orderType") === "dine_in" ? (
                <Form.Item
                  name="tableNo"
                  rules={[
                    {
                      required: true,
                      pattern: /^[1-9][0-9]?$|^100$/,
                      message: "Invalid Table Number",
                    },
                  ]}
                  label="Table Number"
                >
                  <Input
                    type="number"
                    style={{
                      width: "100%",
                    }}
                  />
                </Form.Item>
              ) : null;
            }}
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) =>
              prevValues.orderType !== currentValues.orderType
            }
          >
            {({ getFieldValue }) => {
              return getFieldValue("orderType") === "dine_in" &&
                onGoingOrderList.length > 0 ? (
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Please select On Going Order",
                    },
                  ]}
                  label="On Going Order"
                  name="onGoingOrder"
                >
                  <Select
                    inputProps={{ "aria-label": "Without label" }}
                    style={{
                      width: "100%",
                    }}
                  >
                    {onGoingOrderList.map((i) => {
                      return (
                        <Select.Option key={i.orderId} value={i.orderId}>
                          Token No {i.orderId}
                        </Select.Option>
                      );
                    })}

                    <Select.Option value={"new"}>New Order</Select.Option>
                  </Select>
                </Form.Item>
              ) : null;
            }}
          </Form.Item>
          <Form.Item label="Waiter Name/Code" name="waiterName">
            <Input
              style={{
                width: "100%",
              }}
            />
          </Form.Item>

          <Divider />
          <div
            style={{
              textAlign: "right",
              marginTop: "8px",
            }}
          >
            <Button onClick={handleClose} type="link">
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                marginLeft: "16px",
              }}
            >
              Print
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default KotPrintModal;
